import React from 'react';
import { useField } from '@formiz/core';

export const Radio = (props) => {
	const { errorMessage, id, isValid, isSubmitted, setValue, value } =
		useField(props);

	const showError = !isValid && isSubmitted;

	return (
		<div
			className={`field-container ${
				!isValid && isSubmitted ? 'is-error' : ''
			}`}>
			<label>
				{props.label} {props.required && '*'}
			</label>
			<div className='radio-group'>
				<label>
					<input
						type='radio'
						name={id}
						value='Yes'
						checked={value === 'Yes'}
						onChange={(e) => setValue(e.target.value)}
					/>
					Yes
				</label>
				<label>
					<input
						type='radio'
						name={id}
						value='No'
						checked={value === 'No'}
						onChange={(e) => setValue(e.target.value)}
					/>
					No
				</label>
			</div>
			{props.showPopup && value === 'Yes' && (
				<textarea
					className='popup-textarea'
					placeholder={props.popupPlaceholder}
					onChange={(e) => setValue({ value: 'Yes', details: e.target.value })}
				/>
			)}
			{showError && (
				<div
					id={`${id}-error`}
					className='error-feedback'>
					{errorMessage}
				</div>
			)}
		</div>
	);
};
